import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './BreakingNewsBar.css';

export default function BreakingNewsBar() {
  const [breakingNews, setBreakingNews] = useState([]);

  useEffect(() => {
    axios.get('https://ppmn.net/dash/api/Breaking-News/Section')
      .then(response => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          setBreakingNews(response.data.map(item => item.content));
        }
      })
      .catch(error => {
        console.error("خطأ في جلب الخبر العاجل:", error);
      });
  }, []);

  if (breakingNews.length === 0) return null;

  return (
    <div className="breaking-news-bar d-flex align-items-center">
      <span className="breaking-news-label" style={{ fontSize: "20px", fontWeight: "bold" }}>عاجل</span>
      <div className="breaking-news-text">
        <div className="scrolling-text" style={{ fontSize: "20px", whiteSpace: "nowrap" }}>
          {breakingNews.map((news, index) => (
            <span key={index} style={{ marginInlineEnd: "50px" }}>
              {news}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
